var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',[_vm._v("Senast uppdaterad "+_vm._s(_vm._f("formattedTimeDate")(_vm.date)))])])}
var staticRenderFns = []
export { render, staticRenderFns }